import React from 'react'
import { getStaticImage } from 'utils/statics'

import './styles.scss'
/**
 * It returns a div with an image that resets the filters
 * @param props - {}
 * @param {string} status on || of
 * @param {Function} resetFilters
 * @returns A React component
 */
const IconBar = ({ status='off', resetFilters }) => {
  return (
    <div className='groupIcon'>
      <img
        style={{ cursor:'pointer' }}
        src={getStaticImage(`/icons/orange-brand/icon-filter-grey-${status}.svg`)}
        alt='Filter'
        onClick={resetFilters}
        width={23}
        height={23}
      />
    </div>
  )
}

export default IconBar